exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__payment-card-number___1V3Ng{position:relative;z-index:10;display:flex;align-items:center;flex-flow:column;justify-content:center;margin-top:1rem;letter-spacing:.4px;color:#ecf0f1;font-family:OCR A Std;font-size:21px;opacity:.85;text-shadow:0 1px 3px rgba(44,62,80,.7)}", ""]);

// exports
exports.locals = {
	"payment-card-number": "styles__payment-card-number___1V3Ng"
};